import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

class OrderService extends CustomEventDispatcher {

  constructor() {
    super()
    this.response = {};
  }

  async getOrder(orderId) {
    try {
      const response = await api.get(`/api/order/${orderId}`, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const order = response.data

      const event = new CustomEvent('orderLoaded', { detail: order });
      //small timeout required to let data be incorporated in table
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return order
    } catch (error) {
      console.error('Er is een fout opgetreden in getOrder():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        this._dispatchCustomEvent('orderLoadedFailed', error.response.data);
      }
      return {}
    }
  }

  async getOrderstatussen() {
    try {
      const response = await api.get(`/api/order/statussen`, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const orderstatussen = response.data

      const event = new CustomEvent('orderstatussenLoaded', { detail: orderstatussen });
      //small timeout required to let data be incorporated in table
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return orderstatussen
    } catch (error) {
      console.error('Er is een fout opgetreden in getOrderStatussen():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        this._dispatchCustomEvent('getOrderStatussenFailed', error.response?.data);
      }
      return []
    }
  }

  async updateOrderlineProperty(prop) {
    try {
      const response = await api.post(`/api/order/orderlineprop/update`, prop, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const orderlineprop = response.data

      const event = new CustomEvent('orderlinepropUpdated', { detail: orderlineprop });
      //small timeout required to let data be incorporated in table
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return orderlineprop
    } catch (error) {
      console.error('Er is een fout opgetreden in updateOrderlineProperty:', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        this._dispatchCustomEvent('updateOrderlinePropertyFailed', error.response.data);
      }
      return { success: false, message: error.response ? error.response.data : error.message }
    }
  }

  async updateAddressCode(orderId, code) {
    try {
      const response = await api.get(`/api/order/addresscode/update/${orderId}/${code}`, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = response.data

      const event = new CustomEvent('orderAddresscodeUpdated', { detail: data });
      //small timeout required to let data be incorporated in table
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);
      return data
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        console.error('Er is een fout opgetreden in updateOrderlineProperty:', error);
      }
      return { success: false, message: error.response ? error.response.data : error.message }
    }
  }

  async fetchUnit4DebtorAddresses(debtorCode, orderId) {
    try {
      const url = orderId
        ? `/api/order/unit4/debtor/${encodeURIComponent(debtorCode)}?orderId=${encodeURIComponent(orderId)}`
        : `/api/order/unit4/debtor/${encodeURIComponent(debtorCode)}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      return { success: false, message: error.response?.data?.message || error.message, errors: error.response?.data?.errors || [] };
    }
  }

  async updateDebtorCode(orderId, debtorCode) {
    try {
      const response = await api.get(`/api/order/debtorcode/update/${orderId}/${debtorCode}`, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = response.data

      const event = new CustomEvent('orderDebtorCodeUpdated', { detail: data });
      //small timeout required to let data be incorporated in table
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);
      return data
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        console.error('Er is een fout opgetreden in updateDebtorCode:', error);
      }
      return { success: false, message: error.response ? error.response.data : error.message }
    }
  }

  async updateOrderStatus(orderId, statusId) {
    const url = `/api/order/${orderId}/status`;
    try {
      const response = await api.put(url, { statusId }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const updatedOrder = response.data;
      const event = new CustomEvent('orderStatusUpdated', { detail: updatedOrder });
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);
      return { success: true, data: updatedOrder };
    } catch (error) {
      console.error('Er is een fout opgetreden in updateOrderStatus():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        this._dispatchCustomEvent('updateOrderStatusFailed', error.response ? error.response.data : error);
      }
      return { success: false, message: error.response ? error.response.data : error.message };
    }
  }

  async saveOrderOutput(orderId, newOutput) {
    try {
      const response = await api.put(`/api/order/${orderId}/output`, newOutput, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return { success: true, data: response.data?.data };
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
        return { success: false, status: 401, message: 'Niet geautoriseerd' };
      }
      const status = error?.response?.status;
      const message = error?.response?.data?.message || error?.response?.data?.error || error.message || 'Opslaan mislukt';
      console.error('Er is een fout opgetreden in saveOrderOutput():', error);
      return { success: false, status, message };
    }
  }

  async retryOrder(orderId, newOutput) {
    console.log('orderId:', orderId);
    console.log('newOutput:', newOutput);
    try {
      const response = await api.put(`/api/order/${orderId}/retry`, newOutput, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = response.data;

      // Check if the backend returned success: false
      if (data.success === false) {
        return {
          success: false,
          message: data.message || data.error || 'Er is een fout opgetreden bij het opnieuw versturen van de order'
        };
      }

      const updatedOutput = data.data || data;
      const event = new CustomEvent('orderOutputUpdated', { detail: updatedOutput });
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return { success: true, data: updatedOutput };
    } catch (error) {
      console.error('Er is een fout opgetreden in retryOrder():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
        return { success: false, message: 'Niet geautoriseerd' };
      } else {
        this._dispatchCustomEvent('updateOrderOutputFailed', error.response ? error.response.data : error);
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Er is een onbekende fout opgetreden';
        return { success: false, message: errorMessage };
      }
    }
  }

  async retryOrderWithOriginalInput(orderId, xmlInput) {
    console.log('orderId:', orderId);
    try {
      const response = await api.put(`/api/order/${orderId}/retry-original`, xmlInput, {
        headers: {
          'Content-Type': 'text/xml'
        }
      });

      const data = response.data;

      // Check if the backend returned success: false
      if (data.success === false) {
        return {
          success: false,
          message: data.message || data.error || 'Er is een fout opgetreden bij het opnieuw versturen van de order'
        };
      }

      const updatedOutput = data.data || data;
      const event = new CustomEvent('orderOutputUpdated', { detail: updatedOutput });
      setTimeout(() => {
        this.dispatchEvent(event);
      }, 100);

      return { success: true, data: updatedOutput };
    } catch (error) {
      console.error('Er is een fout opgetreden in retryOrderWithOriginalInput():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
        return { success: false, message: 'Niet geautoriseerd' };
      } else {
        this._dispatchCustomEvent('updateOrderOutputFailed', error.response ? error.response.data : error);
        const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Er is een onbekende fout opgetreden';
        return { success: false, message: errorMessage };
      }
    }
  }

  async saveAsNew(orderId, newOutput) {
    try {
      const response = await api.post(`/api/order/${orderId}/saveAsNew`, newOutput);
      return response.data;
    } catch (error) {
      console.error('Er is een fout opgetreden in saveAsNew():', error);
      return { success: false, message: error.response ? error.response.data : error.message };
    }
  }

  async fetchProductCode(data) {
    try {
      const response = await api.post(`/api/order/product/fetchProductCode`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        console.log('Product kon niet worden gevonden in fetchProductCode():', error);
        this._dispatchCustomEvent('fetchProductCodeFailed', error.response ? error.response.data?.message : error.message);
      }
      return { success: false, message: error.response ? error.response.data?.message : error.message };
    }
  }

  async lookupProductByDescription(description) {
    try {
      const response = await api.post(`/api/product-lookup`, { description }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      } else {
        console.log('Product lookup failed in lookupProductByDescription():', error);
        this._dispatchCustomEvent('lookupProductByDescriptionFailed', error.response ? error.response.data?.message : error.message);
      }
      return { success: false, message: error.response ? error.response.data?.message : error.message };
    }
  }

  async checkDuplicate(orderId, reference = null, debtorCode = null) {
    try {
      // Build query params if reference or debtorCode provided
      const params = {};
      if (reference) params.reference = reference;
      if (debtorCode) params.debtorCode = debtorCode;

      const response = await api.get(`/api/order/${orderId}/check-duplicate`, { params });
      return response.data;
    } catch (error) {
      console.error('Error checking duplicate order:', error);
      return { success: false, message: error.response ? error.response.data?.message : error.message };
    }
  }

  async checkVoNumber(orderId) {
    try {
      const response = await api.post(`/api/order/${orderId}/check-vo-number`);
      return response.data;
    } catch (error) {
      console.error('Error checking VO number:', error);
      return { success: false, message: error.response ? error.response.data?.message : error.message };
    }
  }

  async deleteOrder(id) {
    const response = await api.delete(`/api/order/${id}`);
    return response.data;
  }

  // Haalt de huidige Unit4-orderstatus op (admin-only). Gebruikt door de toggle-knop in
  // OrderDetail om te bepalen of de order op Onderhanden (O) of Wordt ingegeven (B) staat.
  async getUnit4OrderStatus(orderId) {
    try {
      const response = await api.get(`/api/order/${orderId}/unit4-status`);
      const data = response.data;
      return {
        success: data.success !== false,
        orderStatus: data.orderStatus ?? null,
        orderStatusDescription: data.orderStatusDescription ?? '',
      };
    } catch (error) {
      console.error('Er is een fout opgetreden in getUnit4OrderStatus():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      return { success: false, orderStatus: null, orderStatusDescription: '' };
    }
  }

  // Wijzigt de Unit4-orderstatus (admin-only). orderStatus is 'O' (Onderhanden) of 'B'
  // (Wordt ingegeven). Vereist dat de order al in Unit4 is aangemaakt.
  async setOrderUnit4Status(orderId, orderStatus) {
    try {
      const response = await api.put(`/api/order/${orderId}/unit4-status`, { orderStatus });
      const data = response.data;
      if (data.success === false) {
        return { success: false, message: data.message || data.error || 'Statuswijziging is mislukt' };
      }
      return {
        success: true,
        orderStatus: data.orderStatus ?? orderStatus,
        orderStatusDescription: data.orderStatusDescription ?? '',
      };
    } catch (error) {
      console.error('Er is een fout opgetreden in setOrderUnit4Status():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
        return { success: false, message: 'Niet geautoriseerd' };
      }
      return {
        success: false,
        message: error.response?.data?.message || error.response?.data?.error || error.message || 'Er is een onbekende fout opgetreden',
      };
    }
  }

  // Haalt fysieke voorraad (warehouse 01 + 04) via Unit4 mobilesales op voor de orderlines van een order.
  // Optionele `productCodes` array beperkt de fetch tot specifieke regels — gebruikt door de per-regel refresh-knop.
  async fetchOrderStock(orderId, productCodes = null) {
    try {
      const params = {};
      if (Array.isArray(productCodes) && productCodes.length > 0) {
        params.productCodes = productCodes.join(',');
      }
      const response = await api.get(`/api/order/${orderId}/stock`, { params });
      return response.data;
    } catch (error) {
      console.error('Fout bij ophalen voorraad in fetchOrderStock():', error);
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      return { success: false, stocks: {}, message: error.response?.data?.message || error.message };
    }
  }
}

export default OrderService;
